import { Component, HostListener, OnInit, ViewChild, ElementRef, effect, ChangeDetectorRef } from '@angular/core';
import { ChatStateService } from 'src/app/services/chat-state.service';
import { CoreaiService } from 'src/app/services/coreai.service';
import { RouterService } from 'src/app/services/router.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  
  @ViewChild('sidebarContainer') sidebarContainer!: ElementRef;
  userDetail: any;
  deploymentEnv = environment?.deployment;
  historyTab = false;
  settingsTab = false;
  minWidth = 1200;
  activeTab = '';
  feedbackPageURL = '';
  isOpen = true;
  
  constructor(private routerService:RouterService, private chatStateService: ChatStateService,  private cdr: ChangeDetectorRef, private coreAIService:CoreaiService) {
    switch (this.deploymentEnv) {
      case 'DEV': {
        this.feedbackPageURL = 'https://geniusuat.azurewebsites.net/NavigationNewUI/feedbackAngular.html'
        break;
      }
      case 'PROD': {
        this.feedbackPageURL = 'https://genius-websdk-msad.azurewebsites.net/NavigationNewUI/feedbackAngular.html'
        break; 
      }
      case 'UAT': {
        this.feedbackPageURL = 'https://geniusuat.azurewebsites.net/NavigationNewUI/feedbackAngular.html'
        break;
      }
      default: {
         this.feedbackPageURL = 'https://geniusuat.azurewebsites.net/NavigationNewUI/feedbackAngular.html'
      }

    }
    effect(() => {
      if (this.chatStateService.promptFiredSignal() === true) {
        this.hideSidebar();
      }
      this.userDetail = this.coreAIService.userDetailSignal();
      console.log("Here it is",this.userDetail);
    });
  }

  ngOnInit(): void {
    this.getUserInfo();
    this.checkViewport();
    
  }

  getUserInfo() {
    if (localStorage.getItem('user_detail')) {
      this.userDetail = JSON.parse(localStorage.getItem('user_detail') || "{}")
    }
    this.cdr.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkViewport();
  }

  checkViewport() {
    if(window.innerWidth < this.minWidth) {
      this.isOpen = false;
    }
  }
  onClickSettings() {
    this.settingsTab = !this.settingsTab;
    this.historyTab = false;
  }

  onClickHistory() {
    this.historyTab = !this.historyTab;
    this.settingsTab = false;
  }

  toggleSidebar(event:Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    console.log("Toggle sidebar ", this.isOpen)
  }

  hideSidebar() {
    this.isOpen = false;
  }

  isPlayMode() {
    return this.routerService.isPlayMode();
  }

  isFeedbackPage() {
    return this.routerService.isFeedbackPage();
  }

  isPodcastPage() {
    return this.routerService.isPodcastPage();
  }

  isDatalabsPage() {
    return this.routerService.isDatalabs();
  }


  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    // Only run this check if sidebar is open and we're in mobile view
    if (this.isOpen && window.innerWidth < this.minWidth) {
      if (!this.sidebarContainer.nativeElement.contains(event.target)) {
        this.isOpen = false;
      }
    }
  }
}
